function animateDonateBanner(){
    
    const $banner = $('.donate-banner')
    const banner_width = $banner.width()
    const banner_height = $banner.height()
    // const $small_coins_container = $banner.find('.donate-banner__small-coins')
    const $big_coins_container = $banner.find('.donate-banner__big-coins')
    // const $_small_coins = {}
    const $_big_coins = []
    // const $shadow = $banner.find('.donate-banner__shadow')
    const $box = $banner.find('.donate-banner__box.-box')
    // const $box_shadow = $banner.find('.donate-banner__box.-shadow')
    // const box_position = $box.position()
    // const box_offset = $box.offset()
    // const box_width = $box.width()
    // const box_height = $box.height()

    const $title = $('.donate-banner__title')
    const $button = $('.donate-banner .button')

    const $letters =  $('#dntb_letters')
    const $blank = $('#dntb_blank')

    function $createCoin(type, size){
        return $(`<svg class="donate-banner__coin -${size}"><use href="#${type}"></use></svg>`)
        // const $svg = $(`<svg class="donate-banner__coin -${size}"><use href="#${type}"></use></svg`)
        // $small_coins_container.append($svg)
        // const svgString = new XMLSerializer().serializeToString($svg[0]);
        // const base64SVG = btoa(svgString);
        // const img_src = `data:image/svg+xml;base64,${base64SVG}`;
        // $svg.remove()
        // return $(`<img class="donate-banner__coin -${size}" src="${img_src}" />`)
    }


    function create_big_coins(){
        for(let i = 0; i < 20; i++){
            let $coin 
            if(Math.random() > 0.5){
                $coin = $createCoin('coin', 'big');
            }else{
                $coin = $createCoin('coin_transformed', 'big');
            }
            const x = banner_width * Math.random() - 84
            const y = -200
            $coin.data('x', x)
            $coin.css({
                transform: `translate(${x}px, ${y}px)`,
                'transition-delay': Math.random()*10 + 's',
            })
            $big_coins_container.append($coin)
            $_big_coins.push($coin)
        }
    }

    function startCoinsAnimation(){
        for(const [i, $coin] of $_big_coins.entries()){
            const x = $coin.data('x')
            const y = banner_height + 200;
            $coin.css({
                transform: `translate(${x}px, ${y}px) rotate(${-180 +Math.random()*360}deg)`
            })
            const dom_coin = $coin[0]
            $(dom_coin).on('transitionend', ()=>{
                const y = -200
                if($coin.hasClass('-transition-end')){
                   setTimeout(()=>{
                        $coin.removeClass('-transition-end')
                        const x = $coin.data('x')
                        const y = banner_height + 200;
                        $coin.css({
                            transform: `translate(${x}px, ${y}px) rotate(${-180 +Math.random()*360}deg)`,
                            'transition-duration': '8s',
                        })    
                    }, 100) 
                }
                if($coin.hasClass('-transition-end')){
                    return
                }
                $coin.addClass('-transition-end')                
                const x = banner_width * Math.random()
                $coin.data('x', x)
                $coin.css({
                    transform: `translate(${x}px, ${y}px) rotate(${-180 +Math.random()*360}deg)`,
                    'transition-duration': '0s',
                })
            })
        }
    }

    function step_1(){
        setTimeout(() => {
            $title.addClass('-appear')

        }, 200)
        setTimeout(()=>{
            $button.addClass('-appear')
        }, 700)

        $letters.addClass('-step-1')
        $blank.addClass('-step-1')
        setTimeout(()=>{
            $letters.addClass('-step-2')
            $blank.addClass('-step-2')
        }, 1000)
        setTimeout(()=>{
            $letters.addClass('-step-3')
            $blank.addClass('-step-3')
        }, 1500)

        $banner.addClass('-done-step-1')
        $banner.addClass('-done-step-2')

        setTimeout(() => {
            startCoinsAnimation()
        }, 200)

        
    }

    create_big_coins()

    step_1()
}

export {animateDonateBanner}